<template>
  <div class="my-1 bg-[#F8F8F8] p-1 rounded text-black">
    <div class="text-xl font-medium mb-1">
      Ringkasan Data Order Retur
    </div>
    <BRow class="justify-center gap-5 mx-0">
      <BCol class="bg-[#FFFFFF] p-1 rounded-lg border">
        <div class="d-flex justify-between">
          <div class="mb-1 d-flex gap-2">
            <div class="bg-[#FFEDED] rounded py-[2px] px-[4px]">
              <span class="k-truck-fast text-[#E31A1A] text-3xl" />
            </div>
            <span class="font-medium align-self-center">Jumlah Retur</span>
            <span
              id="tooltip-retur"
              class="k-info-circle align-self-center text-xl text-[#08A0F7]"
            />
            <b-tooltip
              target="tooltip-retur"
              triggers="hover"
              variant="light"
            >
              <div class="text-start">
                <div>
                  <b>Bulan Ini</b> berisi = Jumlah retur di bulan saat ini dibandingkan dengan total jumlah paket yang ordernya DIBUAT di bulan saat ini.
                </div>
                <div class="my-1">
                  <b>Bulan Kemarin</b> berisi = Jumlah retur di bulan kemarin dibandingkan dengan total jumlah paket yang ordernya DIBUAT di bulan kemarin.
                </div>
                <div>
                  Paket Retur masih bisa berubah, karena ada paket yang masih dalam Pengiriman yang belum diterima oleh pembeli.
                </div>
              </div>
            </b-tooltip>
          </div>
          <div>
            <b-dropdown
              :text="filterMetricLabel"
              variant="outline-dark"
              class="mx-50"
              size="sm"
            >
              <b-dropdown-item @click="metricRetur('Bulan ini')">
                Bulan ini
              </b-dropdown-item>
              <b-dropdown-item @click="metricRetur('Bulan lalu')">
                Bulan lalu
              </b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
        <div class="font-semibold text-2xl">
          <b-spinner
            v-if="totalOrderRetur === null"
            small
            variant="primary"
          />
          <span v-else>{{ totalOrderRetur }}/{{ totalOrder }}({{ percentageRetur }}%)</span>
        </div>
      </BCol>
      <BCol class="bg-[#FFFFFF] p-1 rounded-lg border">
        <div class="mb-1 d-flex gap-2">
          <div class="bg-[#DFF3FF] rounded py-[2px] px-[4px]">
            <span class="k-truck-time text-[#08A0F7] text-3xl" />
          </div>
          <span class="font-medium align-self-center">Paket dalam Perjalanan</span>
          <span
            id="tooltip-process"
            class="k-info-circle align-self-center text-xl text-[#08A0F7]"
          />
          <b-tooltip
            target="tooltip-process"
            triggers="hover"
            variant="light"
          >
            <div class="text-start">
              Paket sedang proses dikirimkan ke alamat gudang asal.
            </div>
          </b-tooltip>
        </div>
        <div class="font-semibold text-2xl">
          <b-spinner
            v-if="returOnProcess === null"
            small
            variant="primary"
          />
          <span v-else>{{ returOnProcess }}</span>
        </div>
      </BCol>
    </BRow>
  </div>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import moment from 'moment'
import { firstDateOfMonth, lastMonth, lastDateOfLastMonth } from '@/store/helpers'

export default {
  components: { BRow, BCol },
  props: {
    partnerId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      filterMetricLabel: 'Bulan ini',
      percentageRetur: null,
      totalOrder: null,
      totalOrderRetur: null,
      returOnProcess: null,
    }
  },
  mounted() {
    this.metricRetur('Bulan ini')
    this.getReturOnProcess()
  },
  methods: {
    metricRetur(data) {
      this.totalOrderRetur = null
      this.filterMetricLabel = data
      let start = null
      let end = null
      if (data === 'Bulan ini') {
        start = moment(firstDateOfMonth).format('YYYY-MM-DD')
        end = moment().format('YYYY-MM-DD')
      } else {
        start = moment(lastMonth).format('YYYY-MM-DD')
        end = moment(lastDateOfLastMonth).format('YYYY-MM-DD')
      }
      this.$http_komship.get(`/v1/order/metric-retur/${this.partnerId}?start_date=${start}&end_date=${end}`)
        .then(response => {
          this.percentageRetur = response.data.data.percentage_retur
          this.totalOrder = response.data.data.total_order
          this.totalOrderRetur = response.data.data.total_order_retur
        })
        .catch(err => {
          this.$toast_error({ message: err })
        })
    },
    getReturOnProcess() {
      this.$http_komship.get(`/v1/order/retur-on-process/${this.partnerId}`)
        .then(response => {
          this.returOnProcess = response.data.data.retur_on_process
        })
        .catch(err => {
          this.$toast_error({ message: err })
        })
    },
  },
}
</script>
